export default "__VITE_ASSET__BdhlNdAk__"